// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: '8c355c05-4a1c-4b30-8204-0636a0e0f63a',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '46c7f429-382a-4672-9e3d-abeca7af9f41',
      type: 'Sprite',
      name: 'flag',
      className: '',
      x: 0,
      y: 9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Flag_1st',
      mask: null,
      parent: '8c355c05-4a1c-4b30-8204-0636a0e0f63a',
      stateByName: {
        '2nd': {
          texture: 'Race_Event_Flag_2nd'
        },
        '3rd': {
          texture: 'Race_Event_Flag_3rd'
        }
      }
    },
    {
      id: 'eebb7425-6055-450d-8d9a-0715dc311b05',
      type: 'Text',
      name: 'rankText',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1st',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#a35728',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '8c355c05-4a1c-4b30-8204-0636a0e0f63a',
      stateByName: {
        '2nd': {
          text: '2nd',
          style: {
            stroke: '#024da0'
          }
        },
        '3rd': {
          text: '3rd',
          style: {
            stroke: '#9a422a'
          }
        }
      }
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '2.0.0',
  stateNames: [
    '2nd',
    '3rd'
  ],
  handleResize: false
} as const;

export class RaceEventRankFlagLayout {
  static raw = raw;
  root!: Container;
  flag!: Sprite;
  rankText!: Text;
  StateName!: '2nd' | '3rd';

  constructor() {
    populate(this, raw);
  }
}
